import(/* webpackMode: "eager", webpackExports: ["Countdown"] */ "/app/apps/pickleball/src/modules/apr/countdown/Countdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNavigationWrapper"] */ "/app/apps/pickleball/src/modules/top-navigation/TopNavigationWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.64.1_@types_68af448cc8fcec85b73f91cc861b1f99/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FooterAd"] */ "/app/packages/ui/src/components/global/Footer/FooterAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/app/packages/ui/src/components/global/Header/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooterSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AxeptioScript"] */ "/app/packages/ui/src/components/scripts/AxeptioScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/globals.css");
